import { render, staticRenderFns } from "./PaymentMoneyType.vue?vue&type=template&id=6a82cec8&"
import script from "./PaymentMoneyType.vue?vue&type=script&lang=js&"
export * from "./PaymentMoneyType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports